export default "__VITE_ASSET__Bfx$s4oC__"